export enum PersonCodeType {
    Client = 1,
    User = 3,
    Performer = 4
}
